import {merge} from '#core/utils/config-utils.js';
import {resolveColor} from '#core/utils/color-utils.js';

import {ApplicationHeader} from '#core/application/modules/interface/application-header/index.js';
import {generateSimplePopover} from '#core/application/modules/tiles/popover/index.js';
import {generatePrimaryButton, generateSecondaryButton} from '#core/application/modules/tiles/button/index.js';

export function accountPopoverFactory(PALETTE) {
    const {ACCOUNT_POPOVER_BG, ACCOUNT_POPOVER_BORDER_RADIUS, ACCOUNT_POPOVER_SHADOW} = PALETTE;

    return {
        AccountMenu: {
            popup: merge(
                generateSimplePopover(ACCOUNT_POPOVER_BG, ACCOUNT_POPOVER_BORDER_RADIUS, ACCOUNT_POPOVER_SHADOW),
                {
                    style: {
                        zIndex: 602, // default is 601 and its same as betslip onboarding, which leads to visual bugs
                    },
                    container: {
                        style: {
                            _desktop_width: '272px',
                            right: '0px',
                            top: '47px',
                        },
                    },
                    content: {
                        style: {
                            base: {
                                padding: 0,
                                borderWidth: '1px',
                                borderStyle: 'solid',
                                borderColor: resolveColor(ACCOUNT_POPOVER_BG),
                            },
                        },
                    },
                    arrowheadOffset: '-5px',
                    _mobile_arrowheadOffset: ApplicationHeader.config.showSearchButton ? '-53px' : '-12px',
                }
            ),
            content: {
                container: {
                    itemSpacing: 0,
                    style: {
                        padding: '8px 16px',
                    },
                },
                balanceLabel: {
                    style: {
                        ...PALETTE.ACCOUNT_BALANCE_LABEL_TEXT,
                    },
                },
                toggleBalanceVisibilityButton: {
                    style: {
                        base: {
                            height: '40px',
                            gap: 4,
                            alignItems: 'center',
                            flexDirection: 'row-reverse',
                            ...PALETTE.ACCOUNT_BALANCE_VISIBILITY_BUTTON.TERTIARY_BUTTON_TEXT,
                        },
                    },
                },
                balanceVisibilityToggleIcon: {
                    style: {
                        fill: PALETTE.ACCOUNT_BALANCE_VISIBILITY_BUTTON.TERTIARY_BUTTON_ICON_COLOR,
                        minWidth: 16,
                        width: 16,
                        height: 16,
                    },
                },
                dataRow: {
                    style: {
                        padding: 0,
                        lineHeight: '16px',
                        alignItems: 'center',
                        ...PALETTE.ACCOUNT_BALANCE_DATA_TEXT,
                    },
                },
                totalLabel: {
                    style: PALETTE.ACCOUNT_BALANCE_TOTAL_DATA_TEXT,
                },
                totalValue: {
                    style: PALETTE.ACCOUNT_BALANCE_TOTAL_DATA_TEXT,
                },
                deposit: {
                    button: merge(generatePrimaryButton(PALETTE.ACCOUNT_DEPOSIT_BUTTON), {
                        style: {
                            base: {
                                margin: '16px 0',
                            },
                        },
                    }),
                },
                additionalLinks: {
                    linksContainer: {
                        itemSpacing: 0,
                    },
                    button: {
                        style: {
                            base: {
                                height: 40,
                                alignItems: 'center',
                                ...PALETTE.ACCOUNT_ADDITIONAL_LINK_TEXT,
                            },
                        },
                    },
                    chevron: {
                        style: {
                            fill: PALETTE.ACCOUNT_ADDITIONAL_LINK_ICON_COLOR,
                            padding: '0 0 0 8px',
                            height: 16,
                        },
                    },
                },
                logout: {
                    container: {
                        style: {
                            padding: '0 0 8px',
                        },
                    },
                    button: generateSecondaryButton(PALETTE.ACCOUNT_LOG_OUT_BUTTON),
                },
            },
        },
    };
}
